import { createFileRoute } from '@tanstack/react-router';
import { McpConsentPage } from '@/features/mcp/McpConsentPage';
export const Route = createFileRoute('/_authenticated/mcp/authorize')({
  component: McpConsentPage,
  validateSearch: (search: Record<string, unknown>) => search,
});
